import {
   IContentRevision,
   IPhoneSection,
   TContentDefinition,
   TContentKind,
} from '../interfaces/campaign-v2.types'
type Row = Record<string, any>
/** GET returns runtime snapshots; authoring accepts a smaller, editable definition. */
export const contentRevision = (row: Row): IContentRevision => {
   const kind = row.kind as TContentKind
   const snapshot = row.snapshot || {}
   if (row.definition)
      return {
         id: String(row.id ?? row.revisionId),
         contentId: Number(row.contentId),
         kind,
         definition: row.definition,
         legacyBusinessTypeId: row.legacyBusinessTypeId,
      }
   const common = {
      name: String(snapshot.name || ''),
      businessTypeId: Number(snapshot.businessTypeId),
      ...(snapshot.callerTypes ? { callerTypes: snapshot.callerTypes } : {}),
      ...(snapshot.campaignPhases != null
         ? { campaignPhases: snapshot.campaignPhases }
         : {}),
   }
   let definition: TContentDefinition
   if (kind === 'strategy') {
      const series = snapshot.series || {}
      definition = {
         ...common,
         data: snapshot.data,
         sms: (series.sms || []).map((s: Row) => ({
            id: s.id,
            template: s.template || '',
         })),
         voicemail: (series.voicemail || []).map((s: Row) => ({
            id: s.id,
            template: s.template || '',
         })),
         email: (series.email || []).map((s: Row) => ({
            id: s.id,
            subject: s.subject || '',
            body: s.template_body ?? s.body ?? '',
            contentType: s.content_type ?? s.contentType ?? 'text',
         })),
      }
   } else if (kind === 'phone') {
      const composition = snapshot.composition || {}
      definition = {
         ...common,
         callType:
            composition.callType || snapshot.callDirections?.[0] || 'outbound',
         callDirections: snapshot.callDirections || [],
         leadTypes: snapshot.leadTypes || ['known'],
         firstMessage: snapshot.firstMessage || '',
         sections: (composition.sections || []).map(
            (s: Row): IPhoneSection => ({
               sectionId: s.sectionId,
               name: s.name,
               type: s.type || 'call_outbound',
               order: s.order,
               content: s.content || '',
               ...(s.templateType ? { templateType: s.templateType } : {}),
               protected: s.isEditableByUser === false || s.protected === true,
            })
         ),
      }
   } else if (kind === 'conversation')
      definition = { ...common, content: snapshot.basePrompt || '' }
   else if (kind === 'persona')
      definition = {
         ...common,
         guidance: snapshot.guidance || {
            personaGuidance: null,
            voiceStyle: null,
            speakingGuidance: null,
            conversationStyle: null,
         },
      }
   else throw Error('Unsupported content kind returned by the server.')
   return {
      id: String(row.id ?? row.revisionId),
      contentId: Number(row.contentId),
      kind,
      definition,
      legacyBusinessTypeId: snapshot.legacyBusinessTypeId,
   }
}
